import type { SubLabelData } from "@roman/shared/hooks/PredictionMarket/usePredictionMarketLabels";
import { cn } from "@roman/shared/utils";

interface SubLabelSelectorProps {
  subLabels: SubLabelData[];
  selectedSubLabel: SubLabelData;
  onSubLabelSelect: (label: SubLabelData) => void;
  className: string;
}

export const SubLabelSelector = ({
  subLabels,
  selectedSubLabel,
  onSubLabelSelect,
  className,
}: SubLabelSelectorProps) => {
  return (
    <div className={cn("overflow-hidden relative", className)}>
      <div className="flex w-full h-[40px] overflow-auto hide-scrollbar">
        {subLabels.map((subLabel) => {
          const isSelectedLabel = selectedSubLabel.id === subLabel.id;

          return (
            <div key={subLabel.id} className="h-full">
              <div
                className={cn(
                  "flex items-center hover:cursor-pointer justify-center md:text-sm lg:text-sm xl:text-base w-auto rounded-[6px] h-full whitespace-nowrap",
                  isSelectedLabel ? "text-[#4B57FF]" : "text-gray",
                )}
                onClick={() => onSubLabelSelect(subLabel)}
              >
                <p className="text-center font-medium text-sm px-[12px]">
                  {subLabel.label.split("\n").flatMap((line) => (
                    <span key={line}>
                      {`${line}`}
                      <wbr />
                    </span>
                  ))}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
